import {isDeepEqual} from 'src/utils/isDeepEqual';

export const checkIsChanged = <D>(initialData: D | null, data: D): boolean => (
    initialData
        ? !isDeepEqual({prev: initialData, current: data})
        : false
);
